import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Leaf, ArrowRight } from "lucide-react";
import { PRODUCTS, HERB_IMG_FALLBACK } from "@/data/catalog";

export const HerbDialog = ({ herb, onClose }) => {
  const navigate = useNavigate();
  if (!herb) return null;

  const goToProduct = (productName) => {
    const product = PRODUCTS.find((p) => p.name === productName);
    onClose();
    if (product) navigate(`/products/${product.slug}`);
  };

  return (
    <Dialog open={!!herb} onOpenChange={onClose}>
      <DialogContent
        data-testid="herb-dialog"
        className="max-w-2xl max-h-[90vh] overflow-y-auto bg-[#F9F6F0] p-0"
      >
        <DialogTitle className="sr-only">{herb.name}</DialogTitle>
        <div className="relative h-56 sm:h-64">
          <img
            src={herb.image}
            alt={herb.name}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = HERB_IMG_FALLBACK;
            }}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0e241a]/85 via-transparent to-transparent" />
          <div className="absolute bottom-4 left-6">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#D4AF37] mb-1">
              Super Herb
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white">{herb.name}</h2>
          </div>
        </div>

        <div className="p-6 sm:p-8">
          <p className="flex items-center gap-2 text-sm font-semibold text-[#C05C46] mb-4">
            <Leaf className="w-4 h-4" /> {herb.benefit}
          </p>
          <p data-testid="herb-story" className="text-sm sm:text-base text-[#4B5563] leading-relaxed">
            {herb.story}
          </p>

          {herb.foundIn?.length > 0 && (
            <div className="mt-6 pt-5 border-t border-[#E5E0D8]">
              <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1A4331] mb-3">
                Found in these Eleven Stars products
              </p>
              <div className="flex flex-wrap gap-2">
                {herb.foundIn.map((p) => (
                  <button key={p} onClick={() => goToProduct(p)} data-testid={`herb-product-${p.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                    <Badge className="bg-[#1A4331] hover:bg-[#C05C46] text-white border-none px-4 py-2 text-xs cursor-pointer transition-colors">
                      {p}
                      <ArrowRight className="w-3 h-3 ml-1.5" />
                    </Badge>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
